import { render, staticRenderFns } from "./tiendasCategorias.vue?vue&type=template&id=da72b8e4"
import script from "./tiendasCategorias.vue?vue&type=script&lang=js"
export * from "./tiendasCategorias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports